import { cn } from "@/lib/utils";

interface SpinnerProps extends React.HTMLAttributes<HTMLDivElement> {
    size?: "sm" | "md" | "lg";
    variant?: "default" | "button" | "destructive";
}

export function Spinner({ className, size = "md", variant = "default", ...props }: SpinnerProps) {
    return (
        <div
            className={cn(
                "animate-spin rounded-full border-2 border-transparent",
                {
                    "h-4 w-4": size === "sm",
                    "h-8 w-8": size === "md",
                    "h-12 w-12": size === "lg",
                },
                {
                    "border-t-primary": variant === "default",
                    "border-t-current opacity-70": variant === "button",
                    "border-t-white": variant === "destructive",
                },
                className
            )}
            {...props}
        />
    );
}
